import React from 'react';
import clsx from 'clsx';
import ClickedDuplicatePagePopUp from '../PopUpsValidations/ClickedDuplicatePagePopUp';
import ValidationDublicatePage from '../PopUpsValidations/ValidationDuplicatePage';

const DuplicatePageButton = (props) => {

    const {
        editor,
        selectedPage,
        selectedProject,
        savedPagesPerProject,
        newPageClicked,
        savedPageClicked
    } = props;

    const [openDuplicatePage, setOpenDuplicatePage] = React.useState(false);
    const [openDuplicatePageValidation, setOpenDuplicatePageValidation] = React.useState(false);

    const duplicatePage = () => {
        if(editor.Commands.isActive('view-annotations') === false){
          if (savedPagesPerProject[selectedProject][selectedPage] !== false) {
            setOpenDuplicatePage(true);
          } else {
            setOpenDuplicatePageValidation(true);
          }
        }
    };

    return(
        <>
            <div
              id='duplicatePageButton'
              data-tooltip="Duplicate page"
              data-tooltip-pos="bottom"
              className={clsx('fa', 'fa-clone', 'fa-clone2', 'gjs-pn-btn', 'gjs-pn-btn4')}
              onClick={duplicatePage}
              style={selectedPage < 0 ? { display: 'none' } : null}
              aria-hidden="true"
            />
            <ClickedDuplicatePagePopUp
                openDuplicatePage={openDuplicatePage}
                setOpenDuplicatePage={setOpenDuplicatePage}
                selectedProject={selectedProject}
                selectedPage={selectedPage}
                newPageClicked={newPageClicked}
                editor={editor}
            />
            <ValidationDublicatePage
                openAlert={openDuplicatePageValidation}
                setOpenAlert={setOpenDuplicatePageValidation}
                newPageClicked={newPageClicked}
                savedPageClicked={savedPageClicked}
                selectedProject={selectedProject}
                selectedPage={selectedPage}
            />
        </>
    )

}

export default DuplicatePageButton;